import React, { SyntheticEvent } from 'react';
import { Dropdown, DropdownItemProps } from 'semantic-ui-react';
import { Device } from '../logic/Device';
import { deepCopy } from '../logic/utils';
import { ColorDropdown } from '../ui/ColorDropdown';
import { ChargeDropdown } from '../ui/ChargeDropdown';

import './HeraldryWidget.css';
import './Field.css';
import { ChargePermutations } from '../logic/HeraldryAPI';

interface Props {
    device: Device | undefined,
    changeDevice: (device?: Device) => void,
    options: ChargePermutations,
    historical: boolean;
}
interface State {
}

export class FieldUI extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }
    public render() {
        if (!this.props.device) {
            return <div/>;
        }

        // console.log("FieldUI: this.props.options.field=", this.props.options.field);
        let nbrOptions: DropdownItemProps[] = [];
        for (const n of this.props.options.field) {
            if (Number(n) !== 0) {
                nbrOptions.push({ key: n + "", text: n + "", value: n + "" });
            }
        }

        // const placementOpts: DropdownItemProps[] = [
        //     { key: 'full', value: 'full', text: 'across entire shield', },
        //     { key: 'field', value: 'field', text: 'only in field color', },
        // ];

        return <div>
            <p>
                The "field" is the background behind the entire design.
            </p>

            {/* Color */}
            <div className="heraldry-dropdown">

                <div className="heraldry-field-dropdown">
                    <div className="heraldry-dropdown-label">Color:</div>
                    <div className="heraldry-field-dropdown-menu">
                        <ColorDropdown historical={this.props.historical}
                            color={this.props.device.field.color} onChange={(color: string) => this.onChangeFieldColor(color)} />
                    </div>
                </div>
            </div>

            {/* Charge */}
            <div className="heraldry-field-dropdown">
                <div className="heraldry-dropdown-label">Art:</div>
                <div className="heraldry-dropdown-menus">
                    <div>
                        <ChargeDropdown charge={this.props.device.field.charges?.name}
                            onChange={(charge: string | undefined) => this.onChangeCharge(charge)} />
                    </div>
                    <div className="heraldry-dropdown-menu">
                        <ColorDropdown historical={this.props.historical} disabled={!this.props.device.field.charges}
                            color={this.props.device.field.charges?.color} onChange={(color: string) => this.onChangeChargeColor(color)} />
                    </div>
                    <div className="heraldry-dropdown-menu">
                        <Dropdown compact selection options={nbrOptions} disabled={!this.props.device.field.charges} value={this.props.device.field.charges?.nbr + ""}
                            onChange={(event: SyntheticEvent, data: object) => this.onChangeChargeNumber((data as any).value)} />
                    </div>
                </div>
            </div>
        </div>
    }

    private onChangeFieldColor(color: string) {
        const device: Device = deepCopy(this.props.device);
        device.field.color = color!;
        this.props.changeDevice(device);
    }

    private onChangeCharge(name: string | undefined) {
        console.info("onChangeCharge: " + name);
        const device: Device = deepCopy(this.props.device);
        if (!name) {
            device.field.charges = undefined;
        } else {
            if (!device.field.charges) {
                device.field.charges = {
                    name,
                    color: "SILVER",
                    nbr: 1,
                }
            }
            device.field.charges.name = name!;
        }
        this.props.changeDevice(device);
    }

    private onChangeChargeColor(color: string) {
        const device: Device = deepCopy(this.props.device);
        device.field.charges!.color = color!;
        this.props.changeDevice(device);
    }

    private onChangeChargeNumber(n: number) {
        const device: Device = deepCopy(this.props.device);
        device.field.charges!.nbr = n;
        this.props.changeDevice(device);
    }

}
